import { createContext, useContext } from "react";

interface CarouselScrollerContext {
  ref: React.RefObject<HTMLDivElement>;
}

const carouselScrollerContext = createContext<
  CarouselScrollerContext | undefined
>(undefined);

export const useCarouselScrollerContext = () => {
  const context = useContext(carouselScrollerContext);
  if (context == null) {
    throw new Error(
      "CarouselScroller components must be used within a CarouselScrollerContextProvider"
    );
  }
  return context;
};

export const CarouselScrollerContextProvider = carouselScrollerContext.Provider;
